var map = {
	"./SiAnnouncementBar.vue": "4193",
	"./SiCalculationLoader.vue": "b061",
	"./SiCheckout.vue": "87a1",
	"./SiFeedbackBar.vue": "4d21",
	"./SiProductCard.vue": "f954",
	"./SiReportSharing.vue": "684c",
	"./SiTestimonials.vue": "47bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e14d";